<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">

      <md-dialog-title class = "headingPlant" v-if="mode==='CREATE'">Payroll Adjustment</md-dialog-title>
      <md-dialog-title class = "headingPlant" v-if="mode==='VIEW'">Payroll Adjustment-Read Only</md-dialog-title>
      
        <div id="actionButton" style="margin-top: -50px; margin-left: 500px;">
            <md-button class="md-raised custButton" @click="doCancel"><span class="icons-center material-icons">undo</span>Close</md-button>
            <md-button id="create" v-if="mode=='CREATE'" class="md-raised custButton md-primary" @click="doSettle" v-debounce:click="3000"><span class="icons-center material-icons">pets</span>Settle</md-button>
         </div>
  
      <md-dialog-content >
        <div style="width: 800px; height: 450px">
          <form id="top" @submit.prevent="doSaveUser">
            <md-button type="submit" id="submit" style="display:none;" ></md-button> 
            <span class="info" id="status" style="display:none"></span>
 
            <div style="height: 20px"></div>
            <div v-if="mode=='CREATE'" class = "containerT">
              <div class = "heading1 leftPrint">Payroll Num: {{payrollnumber}}###</div>
              <div class = "heading1 leftPrint">Settlement Date:</div>
              <div class = "heading1 leftPrint">{{this.settleDate}}</div>
              <div class = ""></div>
              <div class = "heading1 leftPrint">Driver Company:</div>
              <div class = "heading1 leftPrint"><master-data-display group="STC_DRIVER_COMPANY" :tag-id="dataForm.masterDataId"/></div>
            </div>

            <div v-if="mode=='VIEW'" class = "containerT">
              <div class = "heading1 leftPrint">Payroll Num: {{payrollnumber}} </div>
              <div class = "heading1 leftPrint">Settlement Date:</div>
              <div class = "heading1 leftPrint">{{this.settleDate}}</div>
              <div class = ""></div>
              <div class = "heading1 leftPrint">Driver Company:</div>
              <div class = "heading1 leftPrint"><master-data-display group="STC_DRIVER_COMPANY" :tag-id="dataForm.masterDataId"/></div>
            </div>

            <dir hight= 20px></dir>
            <div class = "containerh">
              <div class=""></div><h1 class = "heading2 rightPrint">Gross Settlement Amount: {{this.grossAmt}}</h1>
            </div>
            

            <dir hight= 30px></dir>
            <div class = "containerh">
              <div class = "heading2 leftPrint">Standard Deduction and Additions: </div>
              <div class = "heading2 rightPrint">Total Standard Adjustment: {{this.standardAdj}}</div>
            </div>
            
            <div v-if="mode=='CREATE'" class = "container">
              <div class = "cl">Charge type</div>
              <div class = "cr">Deductions Amount</div>
              <div class = "cr">Additions Amount</div>
              <div class = "cl">SCALE</div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtScaleDeduction1"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtScaleAddition1"/></div>
              <div class = "cl">PARKING</div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtParkingDeduction1"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtParkingAddition1"/></div>
              <div class = "cl">MANIFEST BOOKLET</div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtManifestDeduction1"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtManifestAddition1"/></div>
              <div class = "cl">INSURANCE</div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtInsuranceDeduction1"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.amtInsuranceAddition1"/></div>
            </div>

            <div v-if="mode=='VIEW'" class = "container">
              <div class = "cl">Charge type</div>
              <div class = "cr">Deductions Amount</div>
              <div class = "cr">Additions Amount</div>
              <div class = "cl">SCALE</div>
              <div class = "cr"><md-input v-model="dataForm.amtScaleDeduction1" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.amtScaleAddition1" disabled/></div>
              <div class = "cl">PARKING</div>
              <div class = "cr"><md-input v-model="dataForm.amtParkingDeduction1" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.amtParkingAddition1" disabled/></div>
              <div class = "cl">MANIFEST BOOKLET</div>
              <div class = "cr"><md-input v-model="dataForm.amtManifestDeduction1" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.amtManifestAddition1" disabled/></div>
              <div class = "cl">INSURANCE</div>
              <div class = "cr"><md-input v-model="dataForm.amtInsuranceDeduction1" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.amtInsuranceAddition1" disabled/></div>
            </div>

            <dir hight= 20px></dir>
            <div class = "containerh">
              <div class = "heading2 leftPrint">Misc. Deductions and Additons: </div>
              <div class = "heading2 rightPrint">Total Misc Adjustment: {{this.miscAdj}}</div>
            </div>  
            <div v-if="mode=='CREATE'" class = "container">
              <div class = "cl">Charge type</div>
              <div class = "cr">Deductions Amount</div>
              <div class = "cr">Additions Amount</div>
              <div class = "cl"><md-input v-model="dataForm.rmk1"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk1Deduction"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk1Addition"/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk2"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk2Deduction"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk2Addition"/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk3"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk3Deduction"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk3Addition"/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk4"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk4Deduction"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk4Addition"/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk5"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk5Deduction"/></div>
              <div class = "cr"><md-input type="number" v-model="dataForm.rmk5Addition"/></div>
            </div>
        
            <div v-if="mode=='VIEW'" class = "container">
              <div class = "cl">Charge type</div>
              <div class = "cr">Deductions Amount</div>
              <div class = "cr">Additions Amount</div>
              <div class = "cl"><md-input v-model="dataForm.rmk1" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk1Deduction" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk1Addition" disabled/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk2" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk2Deduction" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk2Addition" disabled/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk3" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk3Deduction" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk3Addition" disabled/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk4" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk4Deduction" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk4Addition" disabled/></div>
              <div class = "cl"><md-input v-model="dataForm.rmk5" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk5Deduction" disabled/></div>
              <div class = "cr"><md-input v-model="dataForm.rmk5Addition" disabled/></div>
            </div>

            <div class = "containerh">
              <div class=""></div><div class = "heading2 rightPrint">Net Settlement Amount: {{this.netAmt}}</div>
            </div>


          </form>  
        </div> 
      </md-dialog-content>
    </md-dialog>

    
  </div>
</template>


<style scoped>

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}

.leftPrint {
  margin: 1;
  width: 100%;
  padding: 1px;
  text-align: left;
}

.centerPrint {
  margin: 1;
  width: 100%;
  padding: 1px;
  text-align: center;
}

.rightPrint {
  margin: 1;
  width: 100%;
  padding: 1px;
  text-align: right;
}

.heading1 {
  padding-left: 0px;
  color: black;
  width: 100%;
    /* line-height: 3; */
  font-size: 20px;
  font-family: Roboto Slab;
  margin: 0;
}

.heading2 {
    padding-top: 0px;
    padding-left: 0px;

    color: black;
    width: 100%;
    font-size: 18px;
    font-weight:200;
    font-family: Roboto Slab;
    margin: 0;
  }

.containerT {
  display: grid;
  grid-template-columns: 300px 150px 350px;
  margin-top: 10px;
  margin-left: 20px;
  width: 90%;
  background-color:rgb(167, 200, 220);
  font-size: 15px;
}

.containerh {
  display: grid;
  grid-template-columns: 350px 350px;
  margin-top: 10px;
  margin-left: 20px;
  width: 90%;
  background-color:rgb(210, 227, 180);
  font-size: 15px;
}

.container {
  display: grid;
  grid-template-columns: 200px 200px 200px;
  margin-top: 5px;
  margin-left: 20px;
  width: 90%;
  background-color:rgb(240, 221, 245);
  font-size: 15px;
}

.cl {
    text-align: left;
    height: 20px;
}
.cr {
    text-align: right;
    height: 20px;
}

.hContainer {
  display: flex;
  flex-direction: row;
  /* background-color:grey; */
}

.hContainer div {
  margin: 2px;
  width: 250px;
  text-align: center;
  line-height: 28px;
  font-size: 20px;
  /* background-color:lightpink; */
}

.md-input {
  text-align: right;
}

</style>


<script>
  import { mapGetters } from 'vuex';
  import { validationMixin } from 'vuelidate';
  import callingApiCenter from "./CallingApiCenter.vue";
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import dateFormat from '../utils/dateFormat';
  import DatePicker from './DatePicker.vue';
  import AutocompleteMasterDataMultipleSelect from './AutocompleteMasterDataMultipleSelect.vue';

  const getInitialdataForm = () => ({
    salesOffice: null,
    payrollNumSeq: null,
    payrollNum: null,
    payrollSeq: null,
    driverCompany: null,
    settleDate: null,
    grossAmt: 0.00,
    standardAdj: 0.00,
    miscAdj: 0.00,
    netAmt: 0.00,
    mastergroup: null,
    masterDataId: null,
    amtScaleAddition1: 0.00,
    amtScaleDeduction1: 0.00,
    amtManifestAddition1: 0.00,
    amtManifestDeduction1: 0.00,
    amtParkingAddition1: 0.00,
    amtParkingDeduction1: 0.00,
    amtInsuranceAddition1: 0.00,
    amtInsuranceDeduction1: 0.00,
    rmk1: null,
    rmk2: null,
    rmk3: null,
    rmk4: null,
    rmk5: null,
    rmk1Deduction: 0.00,
    rmk2Deduction: 0.00,
    rmk3Deduction: 0.00,
    rmk4Deduction: 0.00,
    rmk5Deduction: 0.00,
    rmk1Addition: 0.00,
    rmk2Addition: 0.00,
    rmk3Addition: 0.00,
    rmk4Addition: 0.00,
    rmk5Addition: 0.00,
  });

  export default {
  components: { DatePicker, AutocompleteMasterDataMultipleSelect },
    props: {
      mode: String,
      onUpdate: Function,
    },

    data: () => ({
      showDialog: false,
      payrollNum: '', 
      dataForm: getInitialdataForm(),   
      settleDate : '',
      settleDateData : '',
      billings: [],
      payrollnumber: '',
      grossAmt : 0.00,
      standardAdj: 0.00,
      miscAdj: 0.00,
      netAmt: 0.00,
      amtScaleAddition1: 0.00,
      amtScaleDeduction1: 0.00,
      amtManifestAddition1: 0.00,
      amtManifestDeduction1: 0.00,
      amtParkingAddition1: 0.00,
      amtParkingDeduction1: 0.00,
      amtInsuranceAddition1: 0.00,
      amtInsuranceDeduction1: 0.00,
      rmk1Deduction: 0.00,
      rmk2Deduction: 0.00,
      rmk3Deduction: 0.00,
      rmk4Deduction: 0.00,
      rmk5Deduction: 0.00,
      rmk1Addition: 0.00,
      rmk2Addition: 0.00,
      rmk3Addition: 0.00,
      rmk4Addition: 0.00,
      rmk5Addition: 0.00,
    }),

    computed: {
      ...mapGetters([
        "getMasterDataByGroup",
        "getMasterDataName",
        "getMasterDataAsSelectOptionByGroup",
        "getUserProfile",
        'getPermission',
      ]),

      
    },
// async mounted() {

// },

    watch: {
      "dataForm.amtScaleDeduction1"() {
        this.amtScaleDeduction1 = parseFloat(this.dataForm.amtScaleDeduction1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.amtManifestDeduction1"() {
        this.amtManifestDeduction1 = parseFloat(this.dataForm.amtManifestDeduction1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.amtParkingDeduction1"() {
        this.amtParkingDeduction1 = parseFloat(this.dataForm.amtParkingDeduction1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
     },
      "dataForm.amtInsuranceDeduction1"() {
       this.amtInsuranceDeduction1 = parseFloat(this.dataForm.amtInsuranceDeduction1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.amtScaleAddition1"() {
        this.amtScaleAddition1 = parseFloat(this.dataForm.amtScaleAddition1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.amtManifestAddition1"() {
        this.amtManifestAddition1 = parseFloat(this.dataForm.amtManifestAddition1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.amtParkingAddition1"() {
        this.amtParkingAddition1 = parseFloat(this.dataForm.amtParkingAddition1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.amtInsuranceAddition1"() {
        this.amtInsuranceAddition1 = parseFloat(this.dataForm.amtInsuranceAddition1);
        this.standardAdj = (( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                              (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                            ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                              (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },

      "dataForm.rmk1Addition"() {
        this.rmk1Addition = parseFloat(this.dataForm.rmk1Addition);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk2Addition"() {
        this.rmk2Addition = parseFloat(this.dataForm.rmk2Addition);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk3Addition"() {
        this.rmk3Addition = parseFloat(this.dataForm.rmk3Addition);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk4Addition"() {
        this.rmk4Addition = parseFloat(this.dataForm.rmk4Addition);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk5Addition"() {
        this.rmk5Addition = parseFloat(this.dataForm.rmk5Addition);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk1Deduction"() {
        this.rmk1Deduction = parseFloat(this.dataForm.rmk1Deduction);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk2Deduction"() {
        this.rmk2Deduction = parseFloat(this.dataForm.rmk2Deduction);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk3Deduction"() {
        this.rmk3Deduction = parseFloat(this.dataForm.rmk3Deduction);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk4Deduction"() {
        this.rmk4Deduction = parseFloat(this.dataForm.rmk4Deduction);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },
      "dataForm.rmk5Deduction"() {
        this.rmk5Deduction = parseFloat(this.dataForm.rmk5Deduction);
        this.miscAdj = (( (this.rmk1Addition) + (this.rmk2Addition) + (this.rmk3Addition) + 
                          (this.rmk4Addition) + (this.rmk5Addition)) - 
                        ( (this.rmk1Deduction) + (this.rmk2Deduction) + (this.rmk3Deduction) + 
                          (this.rmk4Deduction) + (this.rmk5Deduction))).toFixed(2);
        this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
      },


    },


    // validations: {


    // },



    methods: {
      async openDialog(driverCompany, settledate, grossamt, getSelectedItems) {

        this.$store.commit("clearApiError");
        this.dataForm = getInitialdataForm();
        this.grossAmt = 0;
        this.standardAdj = 0;
        this.miscAdj = 0;
        this.netAmt = 0;


        if (this.mode == "CREATE")
        {
          //this.dataForm = await api.post('/api/w/apar/costsearch',
          this.dataForm = await newAPIPost('/api/w/apar/costsearch',
            { mastergroup:"STC_DRIVER_COMPANY",
              masterDataId: driverCompany
            }
          );

          this.payrollnumber = settledate;
          this.settleDate = moment(settledate).format('YYYY/MM/DD');
          this.settleDateData = moment(settledate).format('YYYY-MM-DD');
          this.grossAmt = parseFloat(grossamt).toFixed(2);
          this.billings = getSelectedItems;

          this.amtScaleAddition1 = parseFloat(this.dataForm.amtScaleAddition1).toFixed(2);
          this.amtScaleDeduction1 = parseFloat(this.dataForm.amtScaleDeduction1).toFixed(2);
          this.amtManifestAddition1 = parseFloat(this.dataForm.amtManifestAddition1).toFixed(2);
          this.amtManifestDeduction1 = parseFloat(this.dataForm.amtManifestDeduction1).toFixed(2);
          this.amtParkingAddition1 = parseFloat(this.dataForm.amtParkingAddition1).toFixed(2);
          this.amtParkingDeduction1 = parseFloat(this.dataForm.amtParkingDeduction1).toFixed(2);
          this.amtInsuranceAddition1 = parseFloat(this.dataForm.amtInsuranceAddition1).toFixed(2);
          this.amtInsuranceDeduction1 = parseFloat(this.dataForm.amtInsuranceDeduction1).toFixed(2);

          this.rmk1Deduction = parseFloat(this.dataForm.rmk1Deduction).toFixed(2);
          this.rmk2Deduction = parseFloat(this.dataForm.rmk2Deduction).toFixed(2);
          this.rmk3Deduction = parseFloat(this.dataForm.rmk3Deduction).toFixed(2);
          this.rmk4Deduction = parseFloat(this.dataForm.rmk4Deduction).toFixed(2);
          this.rmk5Deduction = parseFloat(this.dataForm.rmk5Deduction).toFixed(2);
          this.rmk1Addition = parseFloat(this.dataForm.rmk1Addition).toFixed(2);
          this.rmk2Addition = parseFloat(this.dataForm.rmk2Addition).toFixed(2);
          this.rmk3Addition = parseFloat(this.dataForm.rmk3Addition).toFixed(2);
          this.rmk4Addition = parseFloat(this.dataForm.rmk4Addition).toFixed(2);
          this.rmk5Addition = parseFloat(this.dataForm.rmk5Addition).toFixed(2);

          this.standardAdj = ( (this.amtScaleAddition1) + (this.amtManifestAddition1) + 
                                (this.amtParkingAddition1) + (this.amtInsuranceAddition1)) - 
                              ( (this.amtScaleDeduction1) + (this.amtManifestDeduction1) + 
                                (this.amtParkingDeduction1) + (this.amtInsuranceDeduction1));

          this.miscAdj = ( (this.rmk1Addition) + (this.rmk2Addition) + 
                            (this.rmk3Addition) + (this.rmk4Addition) + (this.rmk5Addition)) - 
                          ( (this.rmk1Deduction) + (this.rmk2Deduction) + 
                            (this.rmk3Deduction) + (this.rmk4Deduction) + (this.rmk5Deduction));

          this.netAmt = (parseFloat(this.grossAmt) + parseFloat(this.standardAdj) + parseFloat(this.miscAdj)).toFixed(2);
        };
        
        if (this.mode == "VIEW")
        {       
          this.dataForm = driverCompany[0];
          this.payrollnumber = this.dataForm.payrollNumSeq;
          this.settleDate = moment(this.dataForm.settleDate).format('YYYY/MM/DD');
          this.dataForm.masterDataId = this.dataForm.driverCompany;
          this.grossAmt = parseFloat(this.dataForm.grossAmt).toFixed(2);
          this.standardAdj = parseFloat(this.dataForm.standardAdj).toFixed(2);
          this.miscAdj = parseFloat(this.dataForm.miscAdj).toFixed(2);
          this.netAmt = parseFloat(this.dataForm.netAmt).toFixed(2);

        };

        this.showDialog = true;
      },

      doCancel(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },

      doSettle(){
        //api
        //.post("/api/w/apar/paysettle", {
        newAPIPost("/api/w/apar/paysettle", {
          username: this.getUserProfile.username,
          mode: "create",
          salesOffice: "LGB",
          payrollId: this.payrollnumber,
          driverCompany: this.dataForm.masterDataId,
          settleDate: this.settleDateData,
          grossAmt: this.grossAmt,
          standardAdj: this.standardAdj,
          miscAdj: this.miscAdj,
          netAmt: this.netAmt,
          amtScaleDeduction1: this.dataForm.amtScaleDeduction1,
          amtScaleAddition1: this.dataForm.amtScaleAddition1,
          amtParkingDeduction1: this.dataForm.amtParkingDeduction1,
          amtParkingAddition1: this.dataForm.amtParkingAddition1,
          amtManifestDeduction1: this.dataForm.amtManifestDeduction1,
          amtManifestAddition1: this.dataForm.amtManifestAddition1,
          amtInsuranceDeduction1: this.dataForm.amtInsuranceDeduction1,
          amtInsuranceAddition1: this.dataForm.amtInsuranceAddition1,
          rmk1: this.dataForm.rmk1,
          rmk2: this.dataForm.rmk2,
          rmk3: this.dataForm.rmk3,
          rmk4: this.dataForm.rmk4,
          rmk5: this.dataForm.rmk5,
          rmk1Deduction: this.dataForm.rmk1Deduction,
          rmk2Deduction: this.dataForm.rmk2Deduction,
          rmk3Deduction: this.dataForm.rmk3Deduction,
          rmk4Deduction: this.dataForm.rmk4Deduction,
          rmk5Deduction: this.dataForm.rmk5Deduction,
          rmk1Addition: this.dataForm.rmk1Addition,
          rmk2Addition: this.dataForm.rmk2Addition,
          rmk3Addition: this.dataForm.rmk3Addition,
          rmk4Addition: this.dataForm.rmk4Addition,
          rmk5Addition: this.dataForm.rmk5Addition,
        })
        .then((res) => {
          this.$store.commit("clearApiError");
          var selectItems = this.billings;
          selectItems.forEach( (it) => {  
            it.payrollNum = res;
            })
          const editItem = this.billings
          var result = [];
          const allApiCalls = _(editItem).chain().map((it) => {
            return new Promise((resolve) => {
              //api.post( '/api/w/apar/update',
              newAPIPost( '/api/w/apar/update',
              {
                username: this.getUserProfile.username,
                mode: "payroll",
                salesOffice: "LGB",
                billingNumRateType: it.billingNumRateType,
                payrollNum: res,

              },
              ).then((data) => {
                  it.errorMsg = data;
                  resolve(it)
                }).catch((err) => {
                  it.errorMsg = err.messages.join(';');
                  resolve(it)
                });
              });
            }).value();
                Promise.all(allApiCalls).then((results) => {
                  const resultData = [];
                  _(results)
                    .each(it => resultData.push(it));
          });
          window.confirm("Payroll " + res + " created!");
          this.showDialog = false;
          this.onUpdate();
        });
      },
    },
  };


</script>